"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const SearchByKeyword = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("input", { id: 'keyword', name: 'keyword', type: 'search', autoComplete: 'off', disabled: props.disabled, onChange: val => props.onChange(val.target.value), value: props.value, placeholder: `${translate('search', 'ძებნა')}...`, className: 'form-control form-control-sm' }));
};
exports.default = SearchByKeyword;
